var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "modal-card" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "modal-card-body" }, [
      _c("div", { staticClass: "field" }, [
        _c("label", { staticClass: "label" }, [
          _vm._v("Descripción de la acción"),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "control" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.descripcion,
                expression: "descripcion",
              },
              {
                name: "validate",
                rawName: "v-validate",
                value: { required: true },
                expression: "{required: true}",
              },
            ],
            staticClass: "input",
            class: { "is-danger": _vm.errors.has("Descripcion de la acción") },
            attrs: { name: "Descripcion de la acción" },
            domProps: { value: _vm.descripcion },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.descripcion = $event.target.value
              },
            },
          }),
          _vm._v(" "),
          _c("span", { staticClass: "help" }, [
            _vm._v("Describa en detalle de que se trata la acción"),
          ]),
          _vm._v(" "),
          _vm.errors.has("Descripcion de la acción")
            ? _c("span", { staticClass: "help is-danger" }, [
                _vm._v(_vm._s(_vm.errors.first("Descripcion de la acción"))),
              ])
            : _vm._e(),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "modal-card-foot is-justify-content-flex-end" }, [
      _c(
        "button",
        {
          staticClass: "button is-dark is-outlined",
          attrs: { type: "button" },
          on: {
            click: function ($event) {
              return _vm.$parent.close()
            },
          },
        },
        [_vm._v("Cancelar")]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "button is-primary",
          attrs: { type: "button" },
          on: { click: _vm.submit },
        },
        [_vm._v("Editar")]
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("header", { staticClass: "modal-card-head" }, [
      _c("p", { staticClass: "modal-card-title is-800" }, [
        _vm._v("Editar acción"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }